/**
 * Auth storage helpers – single place for reading user from storage.
 * Supports both { data: user } wrapper and plain user (e.g. after initializeAuth).
 */

const USER_STORAGE_KEY = 'user';

/**
 * Reads the stored user from localStorage or sessionStorage.
 * @returns {Object|null} Unwrapped user object or null
 */
export function getStoredUser() {
  try {
    const raw = localStorage.getItem(USER_STORAGE_KEY) ?? sessionStorage.getItem(USER_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed?.data ?? parsed;
  } catch {
    return null;
  }
}
